import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModuleLayoutComponent } from '../module-layout/module-layout.component';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, ModuleLayoutComponent],
    selector: 'app-root-layout',
    templateUrl: './root-layout.component.html',
})
export class RootLayoutComponent {}
